function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}><title>icon / circle / add-inventory</title><g fill="none" fillRule="evenodd"><circle fill="#06C19C" cx="16" cy="16" r="14" /><g fill="#FFF" fillRule="nonzero"><path d="M14.424 9.697v12.606a1.576 1.576 0 1 0 3.152 0V9.697a1.576 1.576 0 1 0-3.152 0z" /><path d="M9.697 17.576h12.606a1.576 1.576 0 1 0 0-3.152H9.697a1.576 1.576 0 1 0 0 3.152z" /></g></g></svg>;
});